export const SUPPORTED_LANGUAGES = ['sk', 'en', 'pl', 'cs'];
export const DEFAULT_LANGUAGE = 'sk';
export const NON_DEFAULT_LANGUAGES = SUPPORTED_LANGUAGES.filter(l => l !== DEFAULT_LANGUAGE);

export const detectLanguageFromPath = (pathname) => {
  const firstSegment = pathname.split('/')[1];
  return NON_DEFAULT_LANGUAGES.includes(firstSegment) ? firstSegment : DEFAULT_LANGUAGE;
};

export const getLanguagePrefix = (pathname) => {
  const lang = detectLanguageFromPath(pathname);
  return lang === DEFAULT_LANGUAGE ? '' : `/${lang}`;
};

export const stripLanguagePrefix = (path) => {
  for (const lang of NON_DEFAULT_LANGUAGES) {
    if (path.startsWith(`/${lang}/`)) {
      return path.substring(lang.length + 1);
    }
    if (path === `/${lang}`) {
      return '/';
    }
  }
  return path;
};

export const buildBlogPath = (language, slug = '') => {
  const cleanSlug = String(slug || '').replace(/^\/+|\/+$/g, '');
  const prefix = language === DEFAULT_LANGUAGE ? '' : `/${language}`;
  return `${prefix}/blog${cleanSlug ? `/${cleanSlug}` : ''}`;
};

export const getVariantSlug = (variant) =>
  typeof variant?.slug === 'string' ? variant.slug : variant?.slug?.current;

export const isApprovedVariant = (variant) =>
  SUPPORTED_LANGUAGES.includes(variant?.language) &&
  variant?.status === 'approved' &&
  variant?.indexable !== false &&
  Boolean(getVariantSlug(variant));

export const resolveBlogSiblingPath = (
  pathname,
  variants,
  targetLanguage,
  sourceLanguage = DEFAULT_LANGUAGE,
  sourceSlug = ''
) => {
  if (!SUPPORTED_LANGUAGES.includes(targetLanguage) || !Array.isArray(variants)) {
    return null;
  }

  const basePath = stripLanguagePrefix(pathname || '/');
  if (!/^\/blog\/[^/]+$/.test(basePath)) return null;

  if (targetLanguage === sourceLanguage && sourceSlug) {
    return buildBlogPath(sourceLanguage, sourceSlug);
  }

  const target = variants.find(
    (variant) => variant.language === targetLanguage && isApprovedVariant(variant)
  );
  return target ? buildBlogPath(targetLanguage, getVariantSlug(target)) : null;
};

export const buildBlogSiblingEntry = (variant) => {
  if (!isApprovedVariant(variant)) return null;
  return {
    lang: variant.language,
    path: buildBlogPath(variant.language, getVariantSlug(variant)),
  };
};
